import { createSlice } from '@reduxjs/toolkit';
import agentOverviewState from '../../../constants/agents/initialStates/agentOverviewState';

export const agentOverviewSlice = createSlice({
  name: 'agentOverview',
  initialState: agentOverviewState,
  reducers: {
    setAgentOverviewData: (state, action) => {
      state.data = action.payload;
    },
    setAgentOverviewSummary: (state, action) => {
      state.data.summary = action.payload;
    },
    setAgentOverviewVariantSummary: (state, action) => {
      state.variantData.summary = action.payload;
    },
    setAgentOverviewIsSummaryLoading: (state, action) => {
      state.isSummaryLoading = action.payload;
    },
    setAgentOverviewIsVariantSummaryLoading: (state, action) => {
      state.isVariantSummaryLoading = action.payload;
    },
  },
});

export const {
  setAgentOverviewData,
  setAgentOverviewSummary,
  setAgentOverviewVariantSummary,
  setAgentOverviewIsSummaryLoading,
  setAgentOverviewIsVariantSummaryLoading,
} = agentOverviewSlice.actions;
export default agentOverviewSlice.reducer;
